import { combineReducers } from 'redux';
import addonsReducer from './addonsSlice';
import skinsReducer from './skinsSlice';
import worldsReducer from './worldsSlice';
import addonTemplatesReducer from './addonTemplatesSlice';
import mainSkinsReducer from './mainSkinsSlice';
import categoriesReducer from './categoriesSlice';
import commentsReducer from './commentsSlice';
import usersReducer from './usersSlice';
import reportsReducer from './reportsSlice';
import youtubeVideosReducer from './youtubeVideosSlice';
import tipsReducer from './tipsSlice';
import tipStepsReducer from './tipStepsSlice';
import bundlesReducer from './bundlesSlice';
import productsReducer from './productsSlice';
import notificationsReducer from './notificationsSlice';
import sessionsReducer from './sessionsSlice';
import devicesReducer from './devicesSlice';
import challengesReducer from './challengesSlice';
import rewardsReducer from './rewardsSlice';
import bannersReducer from './bannersSlice';
import framesReducer from './framesSlice';
import assetsReducer from './assetsSlice';
import usernameStylesReducer from './usernameStylesSlice';
import bannedIpsReducer from './bannedIpsSlice';

export default combineReducers({
  addons: addonsReducer,
  categories: categoriesReducer,
  skins: skinsReducer,
  worlds: worldsReducer,
  addonTemplates: addonTemplatesReducer,
  mainSkins: mainSkinsReducer,
  comments: commentsReducer,
  users: usersReducer,
  reports: reportsReducer,
  youtubeVideos: youtubeVideosReducer,
  tips: tipsReducer,
  tipSteps: tipStepsReducer,
  bundles: bundlesReducer,
  products: productsReducer,
  notifications: notificationsReducer,
  sessions: sessionsReducer,
  devices: devicesReducer,
  challenges: challengesReducer,
  rewards: rewardsReducer,
  banners: bannersReducer,
  frames: framesReducer,
  assets: assetsReducer,
  usernameStyles: usernameStylesReducer,
  bannedIps: bannedIpsReducer,
})
